import { RotatingSquare } from 'react-loader-spinner';

const LoadingOverlay = ({ show, color = "#ffffff" }) => {
  return <>
    {show && <>
      <div
        className="position-fixed z-index-2000 d-flex align-items-center justify-content-center"
        style={{
          inset: 0,
          // backgroundColor: `rgba(0, 0, 0, 0.3)`
          backgroundColor: `rgb(60 180 229 / 85%)`
        }}
      >
        <RotatingSquare
					ariaLabel="rotating-square"
					visible={true}
					color={color}
					strokeWidth="4"
          className="text-primary"
				/>
      </div>
    </>}
  </>
};

export default LoadingOverlay;
